/**
 * Спінер або назва  на кнопки
 * 
 */
const { Spinner } = require("react-bootstrap");

const spinnerTitle = (titleButton, showSpinner, titleSpinner) => {
    return (showSpinner)
        ? (<>
        <div className="d-flex align-items-center justify-content-center">
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-3">
            
        </Spinner>
        {titleSpinner}
        </div>
        </>)
        : titleButton;
}

export default spinnerTitle;